module.exports = __webpack_public_path__ + "img/sifchain.f94ce831.svg";